import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[siExactMatch]',
  standalone: true,
})
export class ExactMatchDirective {
  private _isExactMatch: boolean;

  @Input()
  set siExactMatch(isExact: boolean ) {
    this._isExactMatch = !!isExact;
  }

  @HostBinding('style')
  get textColor(): Record<string, string> {
    return {
      ...(this._isExactMatch && {
        backgroundColor: '#fafad2',
      }),
    }
  }
}